import type { Ref } from 'react';
import { forwardRef } from 'react';

import { generateDataTestId } from '@/lib/tests';

import { ReactComponent as ChevronLeft } from '@/assets/icons/chevron-left.svg';
import { ReactComponent as ChevronRight } from '@/assets/icons/chevron-right.svg';

import * as S from './BoutiqueSlider.styles';

const MAPPING = {
  next: <ChevronRight />,
  prev: <ChevronLeft />,
};

type NavigationProps = { type: 'next' | 'prev' };

export const Navigation = forwardRef(
  ({ type }: NavigationProps, ref: Ref<HTMLSpanElement>) => {
    return (
      <S.Navigation
        {...generateDataTestId('carousel', type)}
        ref={ref}
        data-testid={`BoutiqueSliderNavigation-${type}`} // Added data-test-id attribute
        type={type}
      >
        {MAPPING[type]}
      </S.Navigation>
    );
  },
);

Navigation.displayName = 'Navigation';
